import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { dbURL } from "./global";

function AddRowForm(props) {
  const navigate = useNavigate();
  const [data, setData] = [props.data, props.setData];
  const { adminAccess } = props;

  const {
    DocType,
    DocNumber,
    ProblemOrError,
    EmployeeInvolved,
    Description,
    DateReportedByManager,
    ApprovedSolution,
    // People,
    canSubmit,
    ID, // if present EDIT, if absent CREATE NEW
  } = data;

  //console.log(data);

  async function loadPeople() {
    const peopleData = await fetch(dbURL + "loadPeople.php", {
      method: "GET",
      mode: "cors",
      credentials: "include",
    });
    const people = await peopleData.json();
    const peopleJSX = people.map((person, index) => {
      return (
        <option value={person.Name} key={index}>
          {person.Name}
        </option>
      );
    });
    setData((prev) => ({
      ...prev,
      People: [people],
      peopleJSX: peopleJSX,
    }));
  }

  useEffect(() => {
    loadPeople();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    addRow();
  }

  async function addRow() {
    try {
      const response = await fetch(dbURL + "addRow.php", {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
      });
      const responseText = await response.text();
      console.log(responseText);
    } catch (error) {
      console.log(error);
    }

    props.setUpdate((prev) => prev + 1);
    props.modalElement.current.innerHTML =
      "<div class='added'>Dodano wpis</div>";
    window.setTimeout(() => {
      navigate("../");
    }, 300);
  }

  function handleChange(e) {
    e.persist();
    console.log(e.target,data);
    const canSubmitValue =
      DocNumber.length > 3 && Description.length > 3 ? true : false;
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      canSubmit: canSubmitValue
    }));
    console.log(data);
  }

  return (
    <form onSubmit={handleSubmit} className="newItem">
      <ol className="formBody">
        <li>
          <label htmlFor="DocType">
            <p>Rodzaj dokumentu sprzedaży</p>
            <select name="DocType" value={DocType} onChange={handleChange}>
              <option value=""></option>
              <option value={0}>Paragon</option>
              <option value={1}>Faktura</option>
            </select>
          </label>
        </li>
        <li>
          <label htmlFor="DocNumber">
            <p>Numer dokumentu sprzedaży</p>
            <input
              type="text"
              name="DocNumber"
              value={DocNumber}
              onChange={handleChange}
            />
          </label>
        </li>
        <li>
          <label htmlFor="ProblemOrError">
            <p>Problem czy błąd pracownika?</p>
            <select
              name="ProblemOrError"
              value={ProblemOrError}
              onChange={handleChange}
            >
              <option value=""></option>
              <option value={0}>Problem</option>
              <option value={1}>Błąd</option>
            </select>
          </label>
        </li>
        <li>
          <label htmlFor="EmployeeInvolved">
            <p>Pracownik związany z błędem lub problemem</p>
            <select
              name="EmployeeInvolved"
              value={EmployeeInvolved}
              onChange={handleChange}
            >
              <option value=""></option>
              {data.peopleJSX}
            </select>
          </label>
        </li>
        <li>
          <label htmlFor="DateReportedByManager">
            <p>Problem zgłoszony przez kier. rec. do KJ dnia:</p>
            <input
              name="DateReportedByManager"
              type="date"
              value={DateReportedByManager}
              onChange={handleChange}
              required={true}
            />
          </label>
        </li>
        <li>
          <label htmlFor="Description">
            <p>Dokładny opis sytuacji</p>
            <textarea
              name="Description"
              value={Description}
              onChange={handleChange}
            />
          </label>
        </li>
        {adminAccess ? (
          <li className="solution">
            <label htmlFor="ApprovedSolution">
              <p>Rozwiązanie sytuacji, zatwierdzone przez KJ</p>
              <textarea
                name="ApprovedSolution"
                value={ApprovedSolution}
                onChange={handleChange}
              />
            </label>
          </li>
        ) : null}
      </ol>
      <div className="buttons">
        <input
          style={{ display: canSubmit ? "block" : "none" }}
          type="submit"
          value={ID ? "Aktualizuj" : "Dodaj"}
        />
        <Link to="../">Wyjdź</Link>
      </div>
    </form>
  );
}
export default AddRowForm;
